import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ValidationService } from '../../validation.service';
import { CommonVariablesService } from '../../common-variables.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-group-master',
  templateUrl: './group-master.component.html',
  styleUrls: ['./group-master.component.css']
})

export class GroupMasterComponent implements OnInit {
  groupNameForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  groupNameTableData: any = [];
  groupID: string;
  submitted = false;
  btnAddShow = false;
  btnUpdateShow = true;
  isViewMode: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private validation: ValidationService
  ) { }

  ngOnInit() {
	window.localStorage.setItem('pageName','');
    this.groupNameForm = this.formBuilder.group({
      txtName: ['', [Validators.required, Validators.pattern('^[A-Z0-9 ]*$')]],
      txtFile: ['']
    });

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    const getUserType = this.commonService.decryptData(tmpUserType);
    this.isViewMode = ((getUserType || '').toLowerCase() == 'adminview');

    this.loadGroupName();
  }

  get f() { return this.groupNameForm.controls; }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the detail of the group master.
  *********************************************/

  async loadGroupName() {
    this.spinner.show();
    let table = $('#groupNameDatatable').DataTable();
    table.destroy();
    let fetchUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/group';
    let fetchData = await this.commonService.httpGetMethod(fetchUrl, 'application/x-www-form-urlencoded', true, '', 'Group Master');
    this.groupNameTableData = [];

    if (fetchData.status == 0) {
      for (var i = 0; i < fetchData.data.length; i++) {
		  fetchData.data[i].u_ts = this.datePipe.transform(new Date(fetchData.data[i].u_ts+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss")
		  this.groupNameTableData.push(fetchData.data[i]);
      }
    }
    else if (fetchData.status != -114) {
      this.commonService.errorsmsg('Fetch Error', 'Error');
    }

    $('#searchGroupname,#searchUpdatedBy,#searchUpdatedTime').val('');
    this.dtTrigger.next();
  }

  /*
  * Created By : Keerthana
  * Description : This function will add the detail in the group master.
  *********************************************/
  async addNewGroupName() {
    this.validateField();
    if (this.groupNameForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      this.spinner.show();
      let txtGroupName = this.groupNameForm.value.txtName.trim();
      let addUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/add/group';
      let addParam = new HttpParams().set('name', txtGroupName);
      let addData = await this.commonService.httpPostMethod(addUrl, addParam, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Group Master');

      if (addData.body.status == 0) {
        this.commonService.successmsg('Group name added successfully', 'Success');
        this.loadGroupName();
        this.resetForm();
      }
      else {
        if (addData.body.status != -114) {
          let tmp = (addData.body.data).split(' ');

          if (tmp[0] == 'Duplicate')
            this.commonService.errorsmsg('Group name already exist', 'Error');
          else
            this.commonService.errorsmsg("Unable to add group name", 'Error');
        }
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will edit the detail in the group master.
  *********************************************/

  editGroupName(oldResponse) {
    this.btnUpdateShow = false;
    this.btnAddShow = true;
    this.groupNameForm.patchValue({
      txtName: oldResponse.group_name,
      txtFile: ''
    });
    this.groupID = oldResponse.group_id;
  }

  /*
  * Created By : Keerthana
  * Description : This function will update the detail in the group master.
  *********************************************/

  async updateGroupName() {
    this.validateField();
    if (this.groupNameForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      this.spinner.show();
      let txtGroupName = this.groupNameForm.value.txtName.trim();
      let updateUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/update/group';
      let updateParam = new HttpParams()
        .set('id', this.groupID)
        .set('name', txtGroupName);
      let updateData = await this.commonService.httpPostMethod(updateUrl, updateParam, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Group Master')

      if (updateData.body.status == 0) {
        this.commonService.successmsg('Group name updated successfully', 'Success');
        this.loadGroupName();
        this.resetForm();
      }
      else {
        if (updateData.body.status == -103) {
          this.commonService.errorsmsg('Group name already exist', 'Error');
        }
        else {
          if (updateData.body.status != -114) {
            let tmp = (updateData.body.data).split(' ');

            if (tmp[0] == 'Duplicate')
              this.commonService.errorsmsg('Group name already exist', 'Error');
            else
              this.commonService.errorsmsg("Unable to add group name", 'Error');
          }
        }
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will delete the detail in the group master.
  *********************************************/

  async deleteGroupName(data) {
    let status = await this.commonService.deleteAlertMsg()
    if (status) {
      this.spinner.show();
      let deleteUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/delete/group/' + data.group_id;
      let deleteData = await this.commonService.httpPostMethod(deleteUrl, '', 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Group Master');

      if (deleteData.body.status == 0) {
        this.commonService.warningmsg('Group name deleted successfully', 'Warning');
        this.loadGroupName();
        this.resetForm();
      }
      else if (deleteData.body.status != -114) {
        this.commonService.errorsmsg('Unable to delete group name', 'Error');
      }
    }
  }

  /*
  * Created By : Dinesh Kumar
  * Description : This function will upload the file in the group master.
  *********************************************/

  async fileUpload(uploadedFile: FileList ) {
	  try{
			if (uploadedFile.length == 0) {
			  this.commonService.errorsmsg('No file chosen', 'Error');
			  return;
			}

			this.spinner.show();
			let fileData = new FormData();
			fileData.append("file", uploadedFile.item(0));
			let url = this.commonVariablesService.baseURL + 'api/v1/marine_master/attach/bulk/group';
			let uploadResponse = await this.commonService.httpPostMethod(url, fileData, '', true, 'Group Master');

			if (uploadResponse.body.status == 0) {
			  if (uploadResponse.body.data.headers.length != 1) {
				this.commonService.errorsmsg('File mismatch, Check column name', 'Error');
				return;
			  }

			  this.commonService.successmsg('File upload initiated', 'Success');
			  let importUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/import/bulk/' + uploadResponse.body.data.key;
			  let params = new HttpParams()
				.set('import_table', 'group')
				.set('headers[0][column]', 'group_name')
				.set('headers[0][field]', 'group_name')
				.set('headers[0][ignore_errors]', 'true')
				.set('headers[0][skip_column]', 'false')
				.set('fields[group_name][name]', 'group_name')
				.set('fields[group_name][type]', 'varchar')
				.set('fields[group_name][size]', '32')
				.set('fields[group_name][null]', 'NO')
				.set('fields[group_name][defvalue]', '')
				.set('fields[group_name][mapped]', 'true');
			  let uploadedResponse = await this.commonService.httpPostMethod(importUrl, params, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Group Master');

			  if (uploadedResponse.body.status == 0) {
				this.commonService.successmsg('File upload successful', 'Success');
				this.resetForm();
				this.loadGroupName();
			  }
			  else if (uploadResponse.body.status != -114) {
				this.commonService.errorsmsg(uploadedResponse.body.txt, 'Error');
			  }
			}
			else {
			  if (uploadResponse.body.status == -103) {
				this.commonService.errorsmsg('Empty file / No data found against column name', 'Error');
			  }
			  else if (uploadResponse.body.status != -114) {
				this.commonService.errorsmsg(uploadResponse.body.txt, 'Error');
			  }
			}
	  }
	  catch(e){
		  this.commonService.errorsmsg(e,'Group Master')
	  }
	  
  }
  /*
	* Created By : Priyadharshini
	* Description : Download sample excel format.
	*********************************************/
	downloadSampleFormat() {
		const fileName = 'group-master.csv'
		const dwldSampleUrl = `./assets/excel/${fileName}`;
		window.open(dwldSampleUrl, "_blank");		//To download the Document in new Tab
	}

  /*
  * Created By : Keerthana
  * Description : This function will reset the form.
  *********************************************/

  resetForm() {
    this.groupNameForm.reset({
      txtName: '',
      txtFile: ''
    });
    this.submitted = false;
    this.btnUpdateShow = true;
    this.btnAddShow = false;
  }

  /*
  * Created By : Dinesh Kumar
  * Description : This function is used to block space,special character & continuous number or character.
  *********************************************/

  validateField() {
    let txtGroupName = this.groupNameForm.value.txtName;
    let fieldsHavingError = this.validation.fieldValidation(this.groupNameForm.value);

    if (fieldsHavingError.fieldName.length > 0) {
      if (txtGroupName.length > 2) {
        this.groupNameForm.controls.txtName.setErrors({ zeroFlag: true });
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will filter the datatable according to search.
  *********************************************/

  filterBySearch() {
    let searchGroupName = $("#searchGroupname").val().toString().toLowerCase();
    let searchUpdatedBy = $("#searchUpdatedBy").val().toString().toLowerCase();
    let searchUpdatedTime = $("#searchUpdatedTime").val().toString().toLowerCase();

    let table = $("#groupNameDatatable").DataTable();
    table.search('').columns().search('').draw();
    if (searchGroupName != "") {
      table.column(0).search(searchGroupName).draw();
    }
    if (searchUpdatedBy != "") {
      table.column(1).search(searchUpdatedBy).draw();
    }
    if (searchUpdatedTime != "") {
      table.column(2).search(searchUpdatedTime).draw();
    }
  }
  
	exportExcel()
	{
	   var tmpArray=[];
	   var tmpObj={};
	   
	   if(this.groupNameTableData.length>0)
	   {
		 for(var i=0;i<this.groupNameTableData.length;i++)
		 {
		  tmpObj={};
			tmpObj['group_name']=this.groupNameTableData[i].group_name;
			tmpObj['author']=this.groupNameTableData[i].author;
			tmpObj['u_ts']=this.groupNameTableData[i].u_ts;
			tmpArray.push(tmpObj)
		 }
		 var datajson= { datajson1: tmpArray };

		 var Heading = [
		   [],
		   ["Group Master"],
		   [],
		   ["Group Name","Updated By","Updated Time"]
		 ];

		 const merge = [
			 { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
			 { s: { r: 1, c: 0 }, e: { r: 1, c: 3 } },
			 { s: { r: 2, c: 0 }, e: { r: 2, c: 3 } },
			 /* { s: { r: 3, c: 0 }, e: { r: 3, c: 3 } }, */
		 ];
		 
		 var wscols = [];
		 //let cell;
		 for (let idx = 0; idx < Heading[3].length; idx++) 
		 {
			 wscols.push({ wch: 25 });  // Common column width
		 }
		 var ws = XLSX.utils.json_to_sheet(Heading);
		 ws['!cols'] = wscols;
		 ws["!merges"] = merge;
		 ws["A1"] = {
			 "t": 's',
			 /* "v": 'TATA MARINE', */
			 "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
		 };
		 XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			 /* header: ["group_name","author","u_ts"], */
			 skipHeader: true,
			 origin: -1
		 });
		 // var alphabets = [''];
		 var wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Group Master");
		 XLSX.writeFile(wb, 'Group_Master.xlsx');
	   }
	   else
	   {
		this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
	   }
	 }
  
}
